const NAV_SECTIONS = [
  { id: "header", label: "الرئيسية" },
  { id: "features", label: "المزايا" },
  { id: "software", label: "البرنامج" },
  { id: "devices", label: "الأجهزة" },
  { id: "pricing", label: "الأسعار" },
  { id: "clients", label: "آراء العملاء" },
  { id: "faq", label: "الأسئلة" },
  { id: "contact", label: "تواصل" },
];
export default NAV_SECTIONS;
